import { Box, Text } from "@chakra-ui/react";
import { ResponsiveBar } from "@nivo/bar";
import { numberFormatter } from "../../../utils";
import { useTranslation } from "react-i18next";
import { Card } from "../../../components/Card";
import { getRandomColor } from "../../Decarbonization/helpers";

function EmissionsDataChart({ data, colors, ...rest }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "dashboard.emissionsDataChart",
  });

  return (
    <Box height={370} {...rest}>
      <ResponsiveBar
        data={data}
        keys={Object.keys(data[0]).filter((key) => key !== "type")}
        indexBy="type"
        margin={{ top: 20, right: 10, bottom: 90, left: 70 }}
        padding={0.3}
        groupMode="grouped"
        valueScale={{ type: "linear" }}
        indexScale={{ type: "band", round: true }}
        colors={(item) => colors[item.id] ?? getRandomColor()}
        borderColor={{
          from: "color",
          modifiers: [["darker", 1.6]],
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 0,
          tickPadding: 10,
          legendPosition: "middle",
          legendOffset: 40,
          tickRotation: -30,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legendPosition: "middle",
          legend: t("totalCO2"),
          legendOffset: -50,
          format: (value) => numberFormatter(value, 2),
        }}
        enableLabel={false}
        legends={[
          {
            dataFrom: "keys",
            anchor: "bottom",
            direction: "row",
            justify: false,
            translateX: 27,
            translateY: 70,
            itemsSpacing: 31,
            itemWidth: 76,
            itemHeight: 19,
            itemDirection: "left-to-right",
            itemOpacity: 0.85,
            symbolSize: 20,
            effects: [
              {
                on: "hover",
                style: {
                  itemOpacity: 1,
                },
              },
            ],
          },
        ]}
        role="application"
        ariaLabel="Emissions data chart"
      />
    </Box>
  );
}

export default EmissionsDataChart;
